/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from 'relay-runtime';
export type QrCodeType = 'REDIRECT' | 'URL' | 'WIFI' | '%future added value';
export type QrCodeRow_qrCode = {
  readonly id: string;
  readonly serialNumber: number;
  readonly type: QrCodeType;
  readonly isDynamic: boolean;
  readonly name: string | null;
  readonly comment: string | null;
  readonly enabled?: boolean | null;
  readonly scanCount?: number | null;
  readonly ' $refType': 'QrCodeRow_qrCode';
};
export type QrCodeRow_qrCode$data = QrCodeRow_qrCode;
export type QrCodeRow_qrCode$key = {
  readonly ' $data'?: QrCodeRow_qrCode$data;
  readonly ' $fragmentRefs': FragmentRefs<'QrCodeRow_qrCode'>;
};

const node: ReaderFragment = {
  argumentDefinitions: [],
  kind: 'Fragment',
  metadata: null,
  name: 'QrCodeRow_qrCode',
  selections: [
    {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'id',
      storageKey: null,
    },
    {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'serialNumber',
      storageKey: null,
    },
    {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'type',
      storageKey: null,
    },
    {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'isDynamic',
      storageKey: null,
    },
    {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'name',
      storageKey: null,
    },
    {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'comment',
      storageKey: null,
    },
    {
      kind: 'InlineFragment',
      selections: [
        {
          alias: null,
          args: null,
          kind: 'ScalarField',
          name: 'enabled',
          storageKey: null,
        },
        {
          alias: null,
          args: null,
          kind: 'ScalarField',
          name: 'scanCount',
          storageKey: null,
        },
      ],
      type: 'RedirectQrCode',
    },
  ],
  type: 'QrCode',
};
(node as any).hash = '20146c98f4ce6a23b16a99bf3050ce75';
export default node;
